import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin, Users } from '../lib/icons';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="bg-blue-600 p-2 rounded-lg mr-3">
                <Heart className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold">Behandlung.de</h3>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Ihre vertrauenswürdige Plattform für Gesundheitsinformationen und qualifizierte 
              Gesundheitsanbieter. Wir verbinden Patienten mit den richtigen Experten.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-gray-300">
                <Mail className="w-4 h-4 mr-2" />
                <a 
                  href="mailto:Kontakt@Behandlung.de"
                  className="hover:text-white transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    const user = 'Kontakt';
                    const domain = 'Behandlung.de';
                    window.location.href = `mailto:${user}@${domain}`;
                  }}
                >
                  Kontakt@Behandlung.de
                </a>
              </div>
              <div className="flex items-center text-gray-300">
                <Phone className="w-4 h-4 mr-2" />
                <a 
                  href="tel:+4941316847166" 
                  className="hover:text-white transition-colors"
                >
                  +49 (0) 4131 6847166
                </a>
              </div>
              <div className="flex items-center text-gray-300">
                <MapPin className="w-4 h-4 mr-2" />
                <span>Hamburg, Deutschland</span>
              </div>
              
              {/* Contact Button */}
              <div className="mt-6">
                <button
                  onClick={() => navigate('/contact')}
                  className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center"
                  aria-label="Kontaktformular oeffnen"
                >
                  <Mail className="w-5 h-5 mr-2" />
                  Kontakt
                </button>
              </div>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Schnellzugriff</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/anbieter')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zum Anbieterverzeichnis"
                >
                  Anbieterverzeichnis
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/krankheiten')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zur Krankheiten-Uebersicht"
                >
                  Krankheiten
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/symptome')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zur Symptome-Uebersicht"
                >
                  Symptome
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/beratung')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zur Beratungs-Uebersicht"
                >
                  Beratung
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/wissen')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zum Gesundheitswissen"
                >
                  Gesundheitswissen
                </button>
              </li>
            </ul>
            
            {/* Register Button */}
            <div className="mt-6">
              <button
                onClick={() => navigate('/register')}
                className="bg-green-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors flex items-center"
                aria-label="Als Gesundheitsanbieter registrieren"
              >
                <Users className="w-5 h-5 mr-2" />
                Als Anbieter registrieren
              </button>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/haftungsausschluss')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zum Haftungsausschluss"
                >
                  Haftungsausschluss
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/agb')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zu den Allgemeinen Geschaeftsbedingungen"
                >
                  AGB
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/datenschutz')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zur Datenschutzerklaerung"
                >
                  Datenschutz
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/impressum')}
                  className="text-gray-300 hover:text-white transition-colors"
                  aria-label="Zum Impressum"
                >
                  Impressum
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Behandlung.de. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;